import { Link } from "react-router-dom";
import { EmptyState } from "../../ui";
import { useNextT } from "../../i18n";
import { ROUTES_PATH } from "../../shell/nav";
import { useAccess } from "../../access/api";
import { routesOpen } from "../../savedRoutes/routesAccess";
import { ManagerHelp } from "../../access/components/ManagerHelp";
import link from "../../access/components/Notices.module.scss";
import s from "./mapStates.module.scss";

/** Board 120.10: typing /map without Plan routes. No menu item leads here; one way forward. */
export const NotForPlanners = () => {
  const { t } = useNextT();
  // Walkthrough m5: "Go to Routes" only for people who have Routes (the menu's rule); contacts-only people and Volunteers have none.
  const { data } = useAccess();
  const hasRoutes = !!data && routesOpen(data.permissions ?? []) && data.hasRoutes !== false;
  return (
    <div className={`cy-next ${s.notFor}`}>
      <EmptyState title={t("map.not_planner.title")} body={t("map.not_planner.body")}
        action={hasRoutes ? <Link to={ROUTES_PATH} className={`${link.link} ${link.primary}`}>{t("map.not_planner.go")}</Link> : undefined} />
      <ManagerHelp />
    </div>
  );
};
